import { get, post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse } from "./types";

// 文件上传相关API
export const uploadApi = {
  /**
   * 上传图片
   * @returns Promise<ApiResponse>
   */
  uploadImg: (base64: string): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.FILE_UPLOAD,
      API_CONFIG.ACTIONS.UPLOAD_IMG
    );

    // 创建 FormData 对象，确保数据以 form-data 格式发送
    const formData = new FormData();
    formData.append("content", base64);

    return post<ApiResponse>(url, formData);
  },
};
